module.exports = __webpack_public_path__ + "img/userCaseNav6.5a7744c7.png";